import 'slick-carousel/slick/slick'

export default class MeetTheTeamSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-team-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {
        if(this.settings.$slider.length) {
            // Loop through each slider and initialize slick individually to avoid conflicts if multiple sliders are on the same page.
            this.settings.$slider.each((index, element) => {
                const $slider = $(element);
                const sliderId = $slider.data('slider-id');

                $slider.slick({
                    autoplay: true,
                    autoplaySpeed: 5000,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true,
                    appendDots: $(`.js-team-slider-dots[data-slider-id="${sliderId}"]`),
                    prevArrow: $(`.js-team-slider-previous[data-slider-id="${sliderId}"]`),
                    nextArrow: $(`.js-team-slider-next[data-slider-id="${sliderId}"]`),

                    responsive: [
                        {
                            breakpoint: 1400,
                            settings: {
                                arrows: false,
                            },
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                        },
                    ],
                });
            });
        }
    }
};

new MeetTheTeamSlider();